<div *ngIf="isBrowser && showBanner()" class="consent-banner">
    <p>We use cookies to improve your experience. By clicking "Accept", you consent to our use of cookies.</p>
    <div class="consent-buttons">
        <button (click)="acceptCookies()" class="accept-btn">Accept</button>
        <button (click)="rejectCookies()" class="reject-btn">Reject</button>
    </div>
</div>
